import * as React from 'react';

import { TagContent } from './tag-content';
import * as Styled from './tag.styles';
import type { InteractiveTagProps } from './tag.types';

export const InteractiveTag = React.forwardRef<
  HTMLDivElement,
  InteractiveTagProps
>(
  (
    {
      badgeProps,
      children,
      className,
      disabled,
      dragging,
      fontWeight,
      hideBorder,
      leadingIcon: LeadingIcon,
      maxWidth,
      onClick,
      profile,
      selected,
      trailingIcon: TrailingIcon,
      value,
      ...props
    },
    forwardedRef
  ): JSX.Element => {
    const hasChildren = Boolean(children);
    const hasLeadingContent =
      !hasChildren || Boolean(LeadingIcon) || Boolean(profile);
    const hasTrailingContent =
      !hasChildren || Boolean(TrailingIcon) || Boolean(badgeProps);

    const handleOnClick = (
      event: React.MouseEvent<HTMLButtonElement, MouseEvent>
    ): void => {
      if (!disabled && onClick) {
        event.currentTarget.dataset.value = value;
        onClick(event);
      }
    };

    return (
      <Styled.InteractiveTag
        $disabled={disabled}
        $dragging={dragging}
        $fontWeight={fontWeight}
        $hasLeadingContent={hasLeadingContent}
        $hasTrailingContent={hasTrailingContent}
        $hideBorder={hideBorder}
        $profile={profile}
        $selected={selected}
        as="button"
        className={className}
        data-xds="InteractiveTag"
        disabled={disabled}
        onClick={handleOnClick}
        ref={forwardedRef}
        type="button"
        value={value}
        {...props}
      >
        <TagContent
          badgeProps={badgeProps}
          disabled={disabled}
          leadingIcon={LeadingIcon && <LeadingIcon width={18} height={18} />}
          maxWidth={maxWidth}
          profile={profile}
          selected={selected}
          trailingIcon={TrailingIcon && <TrailingIcon width={18} height={18} />}
        >
          {children}
        </TagContent>
      </Styled.InteractiveTag>
    );
  }
);

InteractiveTag.displayName = 'InteractiveTag';
